import { render, staticRenderFns } from "./new-user-info.vue?vue&type=template&id=46baec6a&scoped=true"
import script from "./new-user-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-user-info.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./new-user-info.vue?vue&type=style&index=0&id=46baec6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46baec6a",
  null
  
)

export default component.exports